import { combineReducers } from 'redux';

import entries from './entries';
import error from './error';
import isLoading from './isLoading';
import isOpen from './isOpen';
import selected from './selected';

/**
 * @typedef {{
 *   error: string,
 *   isOpen: boolean,
 *   isLoading: boolean,
 *   entries: import('./entries').ServiceHeaderEntriesReducer,
 *   selected: import('./selected').ServiceHeaderSelectedReducer,
 * }} ServiceHeaderReducer
 */

export default combineReducers({
  error,
  isOpen,
  entries,
  selected,
  isLoading,
});
